var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitationCodeExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2015_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 22.5V20.5",
    stroke: "#212529",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5L15 9.5",
    stroke: "#212529",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5L11.463 5.964C12.4008 5.02633 13.6727 4.4996 14.9989 4.49969C16.325 4.49979 17.5968 5.02669 18.5345 5.9645C19.4722 6.90231 19.9989 8.17419 19.9988 9.50035C19.9987 10.8265 19.4718 12.0983 18.534 13.036L18 13.5",
    stroke: "#212529",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 18.5L12.6031 19.034C11.6544 19.9722 10.3739 20.4984 9.03964 20.4984C7.70535 20.4984 6.42489 19.9722 5.47614 19.034C5.0085 18.5716 4.63724 18.021 4.38385 17.4141C4.13047 16.8073 4 16.1561 4 15.4985C4 14.8408 4.13047 14.1897 4.38385 13.5829C4.63724 12.976 5.0085 12.4254 5.47614 11.963L6.00014 11.5",
    stroke: "#212529",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5H22",
    stroke: "#212529",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7.5H4",
    stroke: "#212529",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5V4.5",
    stroke: "#212529",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2015_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationCodeExpired);
export default __webpack_public_path__ + "static/media/invitation_code_expired.94f17dd8c8ce05b549d8490c7d1baf46.svg";
export { ForwardRef as ReactComponent };